export enum CoaNameEnum {
  INCOME = "INCOME",
  COST_OF_SALES = "COST OF SALES",
  NET_PROFIT = "NET PROFIT",
  NET_ASSETS = "NET ASSETS",
  EXPENSES = "EXPENSES",
  DEPRECIATION_ASSETS = "DEPRECIATION - ASSETS",
  OTHER_EXPENSES = "OTHER EXPENSES",
  OTHER_INCOME = "OTHER INCOME"
}